import { createFileRoute, redirect } from '@tanstack/react-router'

import { movedToConsole } from '@/features/auth/require-session'

/** Source health's old address: the console's for the operator, the evaluations for anyone else. */
export const Route = createFileRoute('/_app/source-health')({
  beforeLoad: ({ context }) =>
    movedToConsole(context.queryClient, () =>
      redirect({ to: '/platform/source-health', replace: true }),
    ),
})
